/* eslint-disable react/jsx-pascal-case */
import { DndProvider, useDrag, useDrop } from 'react-dnd'
import { DeleteTwoTone, EditTwoTone, SaveTwoTone } from "@ant-design/icons";
import { Button, Col, Card, InputNumber, ConfigProvider, Form, Input, Row, Space, Typography, Modal, Checkbox, Collapse, Tag, Steps, Tooltip, Empty } from "antd";
import { useRef, useEffect, useContext, useState, useCallback } from "react";
import Label_language from '../../language'
import styled from "styled-components";

import { ItemTypes } from './ItemTypes.js'
import { HTML5Backend } from "react-dnd-html5-backend";
import { isEquals } from "immutability-helper";
import axios from 'axios';

const label_language = Label_language.pms.children.production_processing_management.children.order_temp_process;
const { Text } = Typography;
const { ConfigContext } = ConfigProvider;
const { Panel } = Collapse;
const Modal_ot = styled(Modal)`
`

const colorModel = {
    'default':{
        titleBackgroundColor:'#FFEBCD',
        cardBackgroundColor: '#DFE0DF',
        tagColor: 'default',
        backgroundColor: 'white',
        workingHourBackgroundColor: '#F9F9F9',
        workingHourTagColor:'#F9F9F9'
    },
    'words_setting':{
        titleBackgroundColor:'#D8D8CE',
        cardBackgroundColor: '#F0EBFF',
        tagColor: 'purple',
        backgroundColor: 'white',
        workingHourBackgroundColor: '#F9F9F9',
        workingHourTagColor:'#AE7F6E'
    },
    'words_setting_2':{
        titleBackgroundColor:'#DFC8BE',
        cardBackgroundColor: '#F0EBFF',
        tagColor: 'purple',
        backgroundColor: 'white',
        workingHourBackgroundColor: '#F9F9F9',
        workingHourTagColor:'#AE7F6E'
    },
    'words_setting_3':{
        titleBackgroundColor:'#CBEED0',
        cardBackgroundColor: '#F0EBFF',
        tagColor: 'purple',
        backgroundColor: 'white',
        workingHourBackgroundColor: '#F9F9F9',
        workingHourTagColor:'#AE7F6E'
    }
}

//編輯製程
export const Edit_processes = (
    {
        previousProcesses = [],
        editable = false, 
        moduleID = null, 
        addProcessGroup = [], 
        onAddProcessGroupEnd = () => {},
        modifyProcess = [],
        onModifyProcessEnd = () => {},
        showTitle = false,
        title = '',
        showSaveButton = false,
        saveButtonName = '',
        saveProcessingResultEnd = () => {},
        processingResultID = null,
        getGroupButton = false,
        getGroupButtonName = '',
        getGroupButtonIcon = '',
        getGroupButtonValue = () => {},
        showWorkingHours = false,
        workingHourUnit = '',
        totalWorkingHoursName = false,
        titleBackgroundColor = false,
        backgroundColor = false,
        cardBackgroundColor = false,
        showProcessButton = false,
        processButtonName = '',
        onProcessButtonClick = () => {},
        showAddProcess = false,
        showAddProcessName = false,
        showAddProcessType = 'collapse',
        addProcessData = [],
        direction = 'horizontal',
        showType = 'all',
        stepProps = {},
        colorStyle = 'default',
        addProcessTitleSetting = false
    }
) => {
    const configContext = useContext(ConfigContext)
    const [tempProcesses, setTempProcesses] = useState([])
    const [addProcessGroupThis, setAddProcessGroupThis] = useState([])
    const [modifyProcessThis, setModifyProcessThis] = useState([])
    const [thisProcessingResultID, setThisProcessingResultID] = useState([])
    const [nowShowType, setShowType] = useState('')
    const [addProcessName, setAddProcessName] = useState('')
    const [nowTtotalWorkingHoursName, setNowTotalWorkingHoursName] = useState()
    const [nowAddProcessTitleSetting, setNowAddProcessTitleSetting] = useState({
        title:'',
        groupName:'',
        note:'',
        selected:'',
        processes:'',
        message:''
    })
    
    useEffect(() => {
        if(showAddProcessName) {
            setAddProcessName(showAddProcessName)
        }
        else {
            setAddProcessName(label_language.children.edit_process.children.add[configContext.locale.locale])
        }
    }, [showAddProcessName]);

    useEffect(() => {
        if(totalWorkingHoursName) {
            setNowTotalWorkingHoursName(totalWorkingHoursName)
        }
        else {
            setNowTotalWorkingHoursName('共')
        }
    }, [totalWorkingHoursName]);

    useEffect(() => {
        let tmpTitleSetting = {
            title:label_language.children.edit_process.children.add[configContext.locale.locale],
            groupName:label_language.children.edit_process.children.process_group_name[configContext.locale.locale],
            note:label_language.children.edit_process.children.note[configContext.locale.locale],
            selected:label_language.children.edit_process.children.selected_process[configContext.locale.locale],
            processes:label_language.children.edit_process.children.choose_process[configContext.locale.locale],
            message:label_language.children.edit_process.children.process_group_name.children.message[configContext.locale.locale],
            modify:label_language.children.edit_process.children.modify_process_group[configContext.locale.locale]
        };
        if(addProcessTitleSetting) {
            for(var key in addProcessTitleSetting) {
                tmpTitleSetting[key] = addProcessTitleSetting[key]
            }
        }
        setNowAddProcessTitleSetting(tmpTitleSetting)
    }, [addProcessTitleSetting]);

    useEffect(() => {
        setTempProcesses(previousProcesses)
    }, [previousProcesses]);
    
    useEffect(() => {
        if(addProcessGroup.length !== 0) {
            setAddProcessGroupThis(addProcessGroup)
        }
    }, [addProcessGroup]);

    useEffect(() => {
        if(modifyProcess.length !== 0) {
            setModifyProcessThis(modifyProcess)
        }
    }, [modifyProcess]);

    useEffect(() => {
        if(addProcessGroupThis.length !== 0) {
            setTempProcesses(prev_tempProcesses => [...prev_tempProcesses, addProcessGroupThis])
            setAddProcessGroupThis([])
            onAddProcessGroupEnd()
        }
    }, [addProcessGroupThis]);

    useEffect(() => {
        if(modifyProcessThis.length !== 0) {
            let tempArray = [...tempProcesses]
            let groupIndex = modifyProcessThis['groupIndex']
            let processIndex = modifyProcessThis['processIndex']
            tempArray[groupIndex]['processes'][processIndex] = modifyProcessThis['process']

            setTempProcesses(tempArray)
            setModifyProcessThis([])
            onModifyProcessEnd()
        }
    }, [modifyProcessThis]);

    useEffect(() => {
        setThisProcessingResultID(processingResultID)
    }, [processingResultID]);

    useEffect(() => {
        setShowType(showType);
    }, [showType]);

    const updateAddProcessGroupThis = (processGroup) => {
        processGroup['processes'].forEach((process)=>{
            process['checked'] = 'false'
        })

        setAddProcessGroupThis(processGroup)
    }

    const updateProcessGroup = (processGroup, index) => {
        let newProcessGroup = [...tempProcesses]
        newProcessGroup[index]['process_group_name'] = processGroup['process_group_name']
        newProcessGroup[index]['note'] = processGroup['note']

        setTempProcesses(newProcessGroup)
    }

    //改變工時
    const onChangeWorkingHours = (group_index, item_index, value) => {
        setTempProcesses(tempProcesses.map((group, index)=>{
            if(index === group_index) {
                if('working_hours' in group.processes[item_index]) {
                    group.processes[item_index]['working_hours'] = value
                }
                else {
                    group.processes[item_index] = {...group.processes[item_index], 'working_hours': value};
                }

                let tempWorkingHours = 0
                group.processes.forEach((process)=>{
                    if('working_hours' in process) {
                        tempWorkingHours += process['working_hours']
                    }
                })
                group['total_working_hours'] = tempWorkingHours
            }
            return group
        }))
    }
    const updateTotalWorkingHours = (group_index, value) => {
        setTempProcesses(tempProcesses.map((group, index)=>{
            if(index === group_index) {
                group['total_working_hours'] = value
            }
            return group
        }))
    }

    //移動製程
    const moveProcess = (dragIndex, hoverIndex, group_index, dropped=false) => {

        const arrayCopy = [...tempProcesses];
        let tmp = arrayCopy[group_index]['processes'][hoverIndex]
        arrayCopy[group_index]['processes'][hoverIndex] = arrayCopy[group_index]['processes'][dragIndex]
        arrayCopy[group_index]['processes'][dragIndex] = tmp
        
        arrayCopy[group_index]['processes'][hoverIndex]['isDragging'] = true
        
        setTempProcesses(arrayCopy)
    }
    const dropProcess = (dragIndex, group_index) => {
        const arrayCopy = [...tempProcesses];
        delete arrayCopy[group_index]['processes'][dragIndex]['isDragging']
        setTempProcesses(arrayCopy)
    }

    //移動製程組
    function debounce(func, delay = 250) {
        let timer = null;
    
        return function(...args) {
            let context = this;
        
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        }
    }
    const moveGroupDedounce = (dragIndex, hoverIndex, group_index) => {

        const arrayCopy = [...tempProcesses];
        let tmp = arrayCopy[hoverIndex]
        arrayCopy[hoverIndex] = arrayCopy[dragIndex]
        arrayCopy[dragIndex] = tmp

        // arrayCopy[hoverIndex]['isDragging'] = true

        setTempProcesses(arrayCopy)
    }
    const moveGroup = useCallback(debounce(moveGroupDedounce, 10), [tempProcesses], isEquals);
    const dropGroup = (dragIndex, group_index) => {
        // const arrayCopy = [...tempProcesses];
        // delete arrayCopy[dragIndex]['isDragging']
        // setTempProcesses(arrayCopy)
    }

    const getGroupButtonFunction = (tempProcesses, index) => {
        getGroupButtonValue(tempProcesses[index]);
    }

    const saveProcessGroup = () => {
        tempProcesses.forEach((process, index) => {
            tempProcesses[index]['sequence'] = index
        })

        if(thisProcessingResultID !== null) {
            axios.patch('/pms/api/production_processing/processing_result', {
                'processing_result_id':thisProcessingResultID,
                'processes_groups':tempProcesses,
                'module_id':moduleID
            })
            .then(response => {
                saveProcessingResultEnd(response.data)
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {

            })
        }
        else {
            axios.post('/pms/api/production_processing/processing_result', {
                'processes_groups':tempProcesses, 
                'module_id':moduleID
            })
            .then(response => {
                saveProcessingResultEnd({'processingResultID':response.data})
                setThisProcessingResultID(response.data)
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
    
            })
        }
    }

    if(editable) {
        return (
            <DndProvider backend={HTML5Backend}>
                <div className="site-card-border-less-wrapper">
                    <Card 
                        size="small"
                        bordered={false} >
                        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                        <Row gutter={[8, 8]}>
                            {(showTitle||showSaveButton||showAddProcess)&&
                            <Col span={24}>
                                <Row gutter={[8, 8]}>
                                    <Col span={20}>
                                        {showTitle&&<Typography.Title level={3}>{title}</Typography.Title>}
                                    </Col>
                                    <Col span={2}>
                                        {showAddProcess&&
                                            (
                                                showAddProcessType==='collapse'
                                                ?
                                                <Modal_add_temp_process_collapse
                                                    processes = {addProcessData}
                                                    addProcessName={addProcessName}
                                                    updateAddProcessGroupThis = {updateAddProcessGroupThis}
                                                    titleSetting={nowAddProcessTitleSetting}
                                                />
                                                :
                                                <Modal_add_temp_process
                                                    processes = {addProcessData}
                                                    addProcessName={addProcessName}
                                                    updateAddProcessGroupThis = {updateAddProcessGroupThis}
                                                    titleSetting={nowAddProcessTitleSetting}
                                                />
                                            )
                                        }
                                    </Col>
                                    <Col span={2}>
                                        {showSaveButton&&
                                            <Button 
                                                type="primary" 
                                                style={{ 'float': 'right', 'marginLeft':5}}
                                                onClick={()=>{
                                                    saveProcessGroup()
                                                }}
                                            >
                                                {saveButtonName}
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                            }
                            <Col span={24}>
                                <Row gutter={[8, 8]}>
                                {tempProcesses.length===0?
                                    <Col span={24}>
                                        <Row justify="center">
                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                        </Row>
                                    </Col>
                                    :
                                    tempProcesses.map((tempProcess,index)=>
                                        ('hidden' in tempProcess && tempProcess.hidden==='true')
                                        ?<></>
                                        :
                                        (direction === 'horizontal')
                                        ?
                                            <Col xl={tempProcess.processes.length*4} key={index}>
                                                <DndCard
                                                    group_type={'group'}
                                                    key={tempProcess.sequence}
                                                    index={index}
                                                    group_index={index}
                                                    id={tempProcess.sequence}
                                                    moveCard={moveGroup}
                                                    dropCard={dropGroup}
                                                >
                                                    <Card 
                                                        title={tempProcess.process_group_name}
                                                        headStyle={{backgroundColor: titleBackgroundColor||colorModel[colorStyle]['titleBackgroundColor']}}
                                                        style={
                                                            tempProcess.isDragging?
                                                            {
                                                                background: cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor'],
                                                                border: 'dashed gray'
                                                            }:
                                                            {
                                                                background:backgroundColor||colorModel[colorStyle]['backgroundColor']
                                                            }
                                                        }
                                                        extra={
                                                        <Row gutter={[8, 8]}>
                                                            <Col>
                                                                <Tooltip title={label_language.children.edit_process.children.process_group_name.children.edit_tips[configContext.locale.locale]} color={'orange'}>
                                                                    <Modal_patch_process_group 
                                                                        updateProcessGroup={updateProcessGroup}
                                                                        processGroup={tempProcess}
                                                                        index={index}
                                                                        titleSetting={nowAddProcessTitleSetting}
                                                                    />
                                                                </Tooltip>
                                                            </Col>
                                                            <Col>
                                                                {getGroupButton&&
                                                                    <Tooltip title={label_language.children.edit_process.children.process_group_name.children.save_tips[configContext.locale.locale]} color={'orange'}>
                                                                        <SaveTwoTone
                                                                            onClick={()=>{
                                                                                getGroupButtonFunction(tempProcesses, index)
                                                                            }}
                                                                        />
                                                                    </Tooltip>
                                                                }
                                                            </Col>
                                                            <Col>
                                                                <Tooltip title={label_language.children.edit_process.children.process_group_name.children.delete_tips[configContext.locale.locale]} color={'orange'}>
                                                                    <DeleteTwoTone 
                                                                        onClick={()=>{
                                                                            setTempProcesses(prev_tempProcesses=>prev_tempProcesses.filter((_,index_)=>index_!==index))
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            </Col>
                                                        </Row>
                                                    }>
                                                        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                                                            {('note' in tempProcess)
                                                            ?
                                                            <Row>{tempProcess['note']}</Row>
                                                            :<></>
                                                            }
                                                            <Row gutter={[8, 8]}>
                                                                {tempProcess.processes.map((item,item_index)=>
                                                                    <Col span={Math.trunc(24/tempProcess.processes.length)}>
                                                                        <DndCard
                                                                            group_type={'process'}
                                                                            key={item['process_id']}
                                                                            index={item_index}
                                                                            group_index={index}
                                                                            id={item['process_id']}
                                                                            moveCard={moveProcess}
                                                                            dropCard={dropProcess}
                                                                        >
                                                                            <Card 
                                                                                size="small"
                                                                                color={item.color||cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor']}
                                                                                style={
                                                                                    item.isDragging?
                                                                                    {
                                                                                        height:'6rem',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        background: item.color==='cyan'?'#C3FCF2':false||item.color==='default'?'#DFE0DF':false||cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor'],
                                                                                        border: 'dashed gray'
                                                                                    }:
                                                                                    {
                                                                                        height:'6rem',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        background: item.color==='cyan'?'#C3FCF2':false||item.color==='default'?'#DFE0DF':false||cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor']
                                                                                    }
                                                                                }
                                                                            >
                                                                                <Row>
                                                                                    <Col span={16}>
                                                                                        {!item.isDragging?item.process_name:''}
                                                                                    </Col>
                                                                                    <Col span={6}>
                                                                                        {!item.isDragging&&showProcessButton&&
                                                                                            <Button 
                                                                                                type="primary" 
                                                                                                onClick={()=>{
                                                                                                    onProcessButtonClick({
                                                                                                        processes:tempProcesses,
                                                                                                        groupIndex:index,
                                                                                                        processIndex:item_index
                                                                                                    })
                                                                                                }}
                                                                                            >{processButtonName}
                                                                                            </Button>
                                                                                        }
                                                                                    </Col>
                                                                                    <Col span={24}>
                                                                                        {!item.isDragging&&showWorkingHours&&
                                                                                            <InputNumber 
                                                                                                addonAfter={workingHourUnit}
                                                                                                defaultValue={('working_hours' in item)?item['working_hours']:0}
                                                                                                index={item_index}
                                                                                                onChange={(e) => onChangeWorkingHours(index, item_index, e)}
                                                                                                value={('working_hours' in item)?item['working_hours']:0}
                                                                                                style={{
                                                                                                    'background': '#F9F9F9',
                                                                                                    'border-radius': '6px'
                                                                                                }}
                                                                                            />
                                                                                        }
                                                                                    </Col>
                                                                                </Row>
                                                                            </Card>
                                                                        </DndCard>
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                            {showWorkingHours&&
                                                            <Row justify="end">
                                                                <Col>
                                                                    <Row><Text>{nowTtotalWorkingHoursName}: </Text></Row>
                                                                    <Row>
                                                                        <InputNumber 
                                                                            addonAfter={workingHourUnit}
                                                                            onChange={(e) => updateTotalWorkingHours(index, e)}
                                                                            defaultValue={('total_working_hours' in tempProcess)?tempProcess['total_working_hours']:0}
                                                                            value={('total_working_hours' in tempProcess)?tempProcess['total_working_hours']:0}
                                                                            style={{
                                                                                'background': '#F9F9F9',
                                                                                'border-radius': '6px'
                                                                            }}
                                                                        />
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                            }
                                                        </Space >
                                                    </Card >
                                                </DndCard>
                                            </Col>
                                        :
                                        <Col span={showProcessButton?6:4} key={index}>
                                            <DndCard
                                                group_type={'group'}
                                                key={tempProcess.sequence}
                                                index={index}
                                                group_index={index}
                                                id={tempProcess.sequence}
                                                moveCard={moveGroup}
                                                dropCard={dropGroup}
                                            >
                                                <Card 
                                                    title={tempProcess.process_group_name}
                                                    headStyle={{backgroundColor: titleBackgroundColor||colorModel[colorStyle]['titleBackgroundColor']}}
                                                    style={
                                                        tempProcess.isDragging?
                                                        {
                                                            background: cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor'],
                                                            border: 'dashed gray'
                                                        }:
                                                        {
                                                            background:backgroundColor||colorModel[colorStyle]['backgroundColor']
                                                        }
                                                    }
                                                    extra={
                                                    <Row gutter={[8, 8]}>
                                                        <Col>
                                                            <Tooltip title={label_language.children.edit_process.children.process_group_name.children.edit_tips[configContext.locale.locale]} color={'orange'}>
                                                                <Modal_patch_process_group 
                                                                    updateProcessGroup={updateProcessGroup}
                                                                    processGroup={tempProcess}
                                                                    index={index}
                                                                    titleSetting={nowAddProcessTitleSetting}
                                                                />
                                                            </Tooltip>
                                                        </Col>
                                                        <Col>
                                                            {getGroupButton&&
                                                                <Tooltip title={label_language.children.edit_process.children.process_group_name.children.save_tips[configContext.locale.locale]} color={'orange'}>
                                                                    <SaveTwoTone
                                                                        onClick={()=>{
                                                                            getGroupButtonFunction(tempProcesses, index)
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            }
                                                        </Col>
                                                        <Col>
                                                            <Tooltip title={label_language.children.edit_process.children.process_group_name.children.delete_tips[configContext.locale.locale]} color={'orange'}>
                                                                <DeleteTwoTone 
                                                                    onClick={()=>{
                                                                        setTempProcesses(prev_tempProcesses=>prev_tempProcesses.filter((_,index_)=>index_!==index))
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </Col>
                                                    </Row>
                                                }>
                                                    <Space direction={direction} size="middle" style={{ display: 'flex' }}>
                                                        {('note' in tempProcess)?<Row>{tempProcess['note']}</Row>:<Row></Row>}
                                                        <Row gutter={[8, 8]}>
                                                            {tempProcess.processes.map((item,item_index)=>
                                                                <Col span={24}>
                                                                    <DndCard
                                                                        group_type={'process'}
                                                                        key={item['process_id']}
                                                                        index={item_index}
                                                                        group_index={index}
                                                                        id={item['process_id']}
                                                                        moveCard={moveProcess}
                                                                        dropCard={dropProcess}
                                                                        direction={direction}
                                                                    >
                                                                        <Card 
                                                                            size="small"
                                                                            color={item.color||cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor']}
                                                                            style={
                                                                                item.isDragging?
                                                                                {
                                                                                    height:'6rem',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    background: item.color==='cyan'?'#C3FCF2':false||item.color==='default'?'#DFE0DF':false||cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor'],
                                                                                    border: 'dashed gray'
                                                                                }:
                                                                                {
                                                                                    height:'6rem',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    background: item.color==='cyan'?'#C3FCF2':false||item.color==='default'?'#DFE0DF':false||cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor']
                                                                                }
                                                                            }
                                                                        >
                                                                            <Row gutter={[8, 8]}>
                                                                                <Col span={2}></Col>
                                                                                <Col>
                                                                                    {!item.isDragging?item.process_name:''}
                                                                                </Col>
                                                                                    {!item.isDragging&&showProcessButton&&
                                                                                        <Col span={4}>
                                                                                            <Button 
                                                                                                type="primary" 
                                                                                                onClick={()=>{
                                                                                                    onProcessButtonClick({
                                                                                                        processes:tempProcesses,
                                                                                                        groupIndex:index,
                                                                                                        processIndex:item_index
                                                                                                    })
                                                                                                }}
                                                                                            >{processButtonName}
                                                                                            </Button>
                                                                                        </Col>
                                                                                    }
                                                                            </Row>
                                                                            {!item.isDragging&&showWorkingHours&&
                                                                                <Row>
                                                                                    <Col span={24}>
                                                                                        <InputNumber 
                                                                                            addonAfter={workingHourUnit}
                                                                                            defaultValue={('working_hours' in item)?item['working_hours']:0}
                                                                                            index={item_index}
                                                                                            onChange={(e) => onChangeWorkingHours(index, item_index, e)}
                                                                                            value={('working_hours' in item)?item['working_hours']:0}
                                                                                            style={{
                                                                                                'background': '#F9F9F9',
                                                                                                'border-radius': '6px'
                                                                                            }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                            }
                                                                        </Card>
                                                                    </DndCard>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                        {showWorkingHours&&
                                                        <Row justify="end">
                                                            <Col>
                                                                <Row><Text>{nowTtotalWorkingHoursName}: </Text></Row>
                                                                <Row>
                                                                    <InputNumber 
                                                                        addonAfter={workingHourUnit}
                                                                        onChange={(e) => updateTotalWorkingHours(index, e)}
                                                                        defaultValue={('total_working_hours' in tempProcess)?tempProcess['total_working_hours']:0}
                                                                        value={('total_working_hours' in tempProcess)?tempProcess['total_working_hours']:0}
                                                                        style={{
                                                                            'background': '#F9F9F9',
                                                                            'border-radius': '6px'
                                                                        }}
                                                                    />
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        }
                                                    </Space >
                                                </Card >
                                            </DndCard>
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                        </Row>
                        </Space >
                    </Card >
                </div >
            </DndProvider>
        )
    }
    else if(nowShowType === 'all'){
        return (
            <Row gutter={[4, 4]}>
                {tempProcesses.map((tempProcess,index)=>
                    ('hidden' in tempProcess && tempProcess.hidden==='true')
                    ?<></>
                    :
                    <Col key={index} flex="auto">
                        <Card 
                            title={tempProcess.process_group_name}
                            headStyle={{backgroundColor: titleBackgroundColor||colorModel[colorStyle]['titleBackgroundColor']}}
                            extra={
                                getGroupButton?
                                <Row gutter={[16, 8]}>
                                    <Col>
                                        {getGroupButton&&
                                            <Button 
                                                icon={getGroupButtonIcon}
                                                type="primary" 
                                                onClick={()=>{
                                                    getGroupButtonFunction(tempProcesses, index)
                                                }}
                                            >{getGroupButtonName}
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                                :<></>
                            }
                        >
                            <Space direction="vertical" size="small" style={{ display: 'flex' }}>
                                {
                                    (direction === 'horizontal')
                                    ?
                                    <>
                                        {('note' in tempProcess)?<Row>{tempProcess['note']}</Row>:<Row>&nbsp;</Row>}
                                        <Row gutter={[2, 2]}>
                                            {tempProcess.processes.map((item,item_index)=>
                                                <Col>
                                                    <Tag color={item.color||colorModel[colorStyle]['tagColor']}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                    >
                                                        {item.process_name}
                                                    </Tag>
                                                </Col>
                                            )}
                                        </Row>
                                    </>
                                    :
                                    <>
                                        {('note' in tempProcess)?<Row>{tempProcess['note']}</Row>:<Row>&nbsp;</Row>}
                                        {tempProcess.processes.map((item,item_index)=>
                                            <Row>
                                                <Col span="24">
                                                    <Card size='small'
                                                        style={
                                                            {
                                                                background:item.color||colorModel[colorStyle]['cardBackgroundColor']
                                                            }
                                                        }
                                                    >
                                                        <Row>
                                                            {('working_hours' in item)
                                                            ?
                                                            <>
                                                                <Col flex="auto">{item.process_name}</Col>
                                                                <Col flex="50px"><Tag color={colorModel[colorStyle]['workingHourTagColor']}>{item.working_hours || 0}{workingHourUnit}</Tag></Col>
                                                            </>
                                                            :<Col span={"24"}>{item.process_name}</Col>
                                                            }
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        
                                        )}
                                    </>
                                }
                                {('total_working_hours' in tempProcess)?
                                <Row justify="end">{nowTtotalWorkingHoursName}{'：'}{tempProcess.total_working_hours || 0}{workingHourUnit}</Row>
                                :<></>}
                            </Space >
                        </Card >
                    </Col>
                )}
            </Row>
        )
    }
    else if(nowShowType === 'step'){
        return(
            <Steps
                current={0}
                items={
                    previousProcesses.map((group)=>(
                        ('hidden' in group && group.hidden==='true')
                        ?{}
                        :
                        {
                            title: group.process_group_name,
                            description: 
                            (
                                <Col>
                                    {group['processes'].map((process)=>(
                                        <Row>
                                            <Tag>
                                                {process.process_name}
                                            </Tag>
                                        </Row>
                                    ))}
                                </Col>
                            )
                        }
                    ))}
                {...stepProps}
            />
        )
    }
    else if(nowShowType === 'only_process'){
        return (
            <Row gutter={[4, 4]}>
                {tempProcesses.map((tempProcess,index)=>
                    ('hidden' in tempProcess && tempProcess.hidden==='true')
                    ?<></>
                    :
                    <Col key={index}>
                        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
                            {
                                (direction === 'horizontal')
                                ?
                                <>
                                    {('note' in tempProcess)?<Row>{tempProcess['note']}</Row>:<Row>&nbsp;</Row>}
                                    <Row gutter={[2, 2]}>
                                        {tempProcess.processes.map((item,item_index)=>
                                            <Col>
                                                <Card 
                                                    size="small"
                                                    color={item.color||cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor']}
                                                    style={
                                                        {
                                                            height:'6rem',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            background: item.color==='cyan'?'#C3FCF2':false||item.color==='default'?'#DFE0DF':false||cardBackgroundColor||colorModel[colorStyle]['cardBackgroundColor']
                                                        }
                                                    }
                                                >
                                                    <Row>
                                                        {tempProcess.process_group_name}
                                                    </Row>
                                                    <Row>
                                                        {item.process_name}
                                                    </Row>
                                                </Card>
                                            </Col>
                                        )}
                                    </Row>
                                </>
                                :
                                <>
                                    {('note' in tempProcess)?<Row>{tempProcess['note']}</Row>:<Row>&nbsp;</Row>}
                                    {tempProcess.processes.map((item,item_index)=>
                                    
                                        <Row>
                                            <Tag color={item.color||colorModel[colorStyle]['tagColor']}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                {item.process_name}
                                            </Tag>
                                        </Row>
                                    
                                    )}
                                </>
                            }
                        </Space >
                    </Col>
                )}
            </Row>
        )
    }
    else {
        return(
            <>loading</>
        )
    }
}

//修改製程組
const Modal_patch_process_group = (props) => {
    const [form] = Form.useForm();

    const [processGroupName, setProcessGroupName] = useState([])
    const [note, setNote] = useState([])
    
    useEffect(() => {
        setProcessGroupName(props.processGroup['process_group_name']||'')
        setNote(props.processGroup['note']||'')
    }, [props.processGroup]);

    const [open, set_open] = useState(false)
    const configContext = useContext(ConfigContext)

    const on_finish = (values) => {
        props.updateProcessGroup(values, props.index)
        set_open(false)
    }
    return (<>
        <EditTwoTone
            onClick={() => set_open(true)}
        />
                            
        <Modal_ot
            title={<Typography.Title level={3}>{props.titleSetting.modify}</Typography.Title>}
            open={open}
            style={{
                fontSize: '2rem'
            }}
            width="100vw"
            onCancel={() => set_open(false)}
            footer={<>
                <Button type="primary"
                    onClick={() => form.submit()}
                >{label_language.children.edit_process.children.process_group_name.children.edit_tips.children.confirm[configContext.locale.locale]}</Button>
                <Button
                    onClick={() => set_open(false)}
                >{label_language.children.edit_process.children.process_group_name.children.edit_tips.children.cancel[configContext.locale.locale]}</Button>
            </>}
        >
            <Form
                form={form}
                onFinish={on_finish}
            >
                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: props.titleSetting.message
                        }
                    ]}
                    name="process_group_name"
                    label={<div>{props.titleSetting.groupName}</div>}
                >
                    <Input 
                        defaultValue={processGroupName}
                        value={processGroupName}
                    />
                </Form.Item>
                <Form.Item
                    name="note"
                    label={<div>{props.titleSetting.note}</div>}
                >
                    <Input 
                        defaultValue={note}
                        value={note}
                    />
                </Form.Item>
            </Form>
        </Modal_ot>
    </>)
}

//新增製程組 製程有分類(有Collapse)
const Modal_add_temp_process_collapse = (props) => {
    const [form] = Form.useForm();

    const [processes, setProcesses] = useState([])
    
    useEffect(() => {
        setProcesses(props.processes)
    }, [props.processes]);

    const [open, set_open] = useState(false)
    const [checkedList, setCheckedList] = useState([]);
    const configContext = useContext(ConfigContext)
    const onChange = (e) => {
        if (!checkedList.includes(e.target.value))
            setCheckedList(prev_check_list => [...prev_check_list, e.target.value]);
        else
            setCheckedList(prev_check_list => prev_check_list.filter(option => option !== e.target.value));
    };
    const on_finish = (values) => {
        set_open(false)
        const process_names = checkedList.map(option => {
            let process_name = '';
            processes.forEach((item, index) => {
                const element = item.processes.find(item => item.process_id === option, {});
                if (element && element.hasOwnProperty('process_name')) {
                    process_name = Object.entries(element.process_name).reduce((_, [__, element]) => element, '')
                }
            })
            return {
                'process_name': process_name,
                'process_id': option
            }
        })
        const tempProcess = {
            ...values,
            processes: process_names
        };
        setCheckedList([])
        form.resetFields();
        props.updateAddProcessGroupThis(tempProcess);
    }
    return (<>
        <Button type="primary" style={{ float: 'right' }}
            onClick={() => set_open(true)}
        >
            {props.addProcessName}
        </Button>
                            
        <Modal_ot
            title={<Typography.Title level={3}>{props.addProcessName||props.titleSetting.title}</Typography.Title>}
            open={open}
            style={{
                fontSize: '2rem'
            }}
            width="100vw"
            onCancel={() => set_open(false)}
            footer={<>
                <Button type="primary"
                    onClick={() => form.submit()}
                >{label_language.children.edit_process.children.confirm[configContext.locale.locale]}</Button>
                <Button
                    onClick={() => set_open(false)}
                >{label_language.children.edit_process.children.cancel[configContext.locale.locale]}</Button>
            </>}
        >
            <Form
                form={form}
                onFinish={on_finish}
            >
                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: props.titleSetting.message
                        }
                    ]}
                    name="process_group_name"
                    label={<div>{props.titleSetting.groupName}</div>}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="note"
                    label={<div>{props.titleSetting.note}</div>}
                >
                    <Input />
                </Form.Item>
            </Form>
            <Card
                title={<Typography.Title level={3}>{props.titleSetting.selected}</Typography.Title>}
            >
                <div 
                    style={{ padding:'1rem',height: '10vh',overflow:'scroll' }}
                >
                    {checkedList.map(option => {
                        let process_name = '';
                        processes.forEach((item, index) => {
                            const element = item.processes.find(item => item.process_id === option, {});
                            if (element && element.hasOwnProperty('process_name')) {
                                process_name = Object.entries(element.process_name).reduce((_, [__, element]) => element, '')
                            }
                        })
                        return (<>
                            <Tag color="lime" style={{}}>{process_name}</Tag>
                        </>)
                    })}
                </div>
            </Card>
            <Card
                title={<Typography.Title level={3}>{props.titleSetting.processes}</Typography.Title>}
            >
                <div
                    style={{
                        height: '30vh', overflow: 'scroll'
                    }}
                >
                    <Collapse accordion
                    >
                        {processes.map((item, index) => {
                            const options = item.processes.map(item => ({
                                label: Object.entries(item.process_name).reduce((_, [__, element]) => element, ''),
                                value: item.process_id
                            }));
                            return (<>
                                <Panel header={item.group_name}
                                >
                                    <Row>
                                        {options.map(option =>
                                            <Col>
                                                <Checkbox value={option.value} checked={checkedList.includes(option.value)} onChange={onChange}>{option.label}</Checkbox>
                                            </Col>
                                        )}
                                    </Row>
                                </Panel>
                            </>)
                        })}
                    </Collapse>
                </div>
            </Card>
        </Modal_ot>
    </>)
}

//新增製程組 製程無分類
const Modal_add_temp_process = (props) => {
    const [form] = Form.useForm();

    const [processes, setProcesses] = useState([])
    
    useEffect(() => {
        setProcesses(props.processes)
    }, [props.processes]);

    const [open, set_open] = useState(false)
    const [checkedList, setCheckedList] = useState([]);
    const configContext = useContext(ConfigContext)
    const onChange = (e) => {
        if (!checkedList.includes(e.target.value))
            setCheckedList(prev_check_list => [...prev_check_list, e.target.value]);
        else
            setCheckedList(prev_check_list => prev_check_list.filter(option => option !== e.target.value));
    };
    const on_finish = (values) => {
        set_open(false)
        const process_names = checkedList.map(option => {
            let process_name = '';
            let detail = [];

            const element = processes.find(item => item.process_id === option, {});
            if (element && 'process_name' in element) {
                process_name = element.process_name
            }
            if (element && 'detail' in element) {
                detail = element.detail
            }


            return {
                'process_name': process_name,
                'process_id': option,
                'detail': detail
            }
        })
        const tempProcess = {
            ...values,
            processes: process_names
        };

        setCheckedList([])
        form.resetFields();
        props.updateAddProcessGroupThis(tempProcess);
    }
    return (<>
        <Button type="primary" style={{ float: 'right' }}
            onClick={() => set_open(true)}
        >
            {props.addProcessName}
        </Button>
                            
        <Modal_ot
            title={<Typography.Title level={3}>{props.titleSetting.title||props.addProcessName}</Typography.Title>}
            open={open}
            style={{
                fontSize: '2rem'
            }}
            width="100vw"
            onCancel={() => set_open(false)}
            footer={<>
                <Button type="primary"
                    onClick={() => form.submit()}
                >{label_language.children.edit_process.children.confirm[configContext.locale.locale]}</Button>
                <Button
                    onClick={() => set_open(false)}
                >{label_language.children.edit_process.children.cancel[configContext.locale.locale]}</Button>
            </>}
        >
            <Form
                form={form}
                onFinish={on_finish}
            >
                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: props.titleSetting.message
                        }
                    ]}
                    name="process_group_name"
                    label={<div>{props.titleSetting.groupName}</div>}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="note"
                    label={<div>{props.titleSetting.note}</div>}
                >
                    <Input />
                </Form.Item>
            </Form>
            <Card
                title={<Typography.Title level={3}>{props.titleSetting.selected}</Typography.Title>}
            >
                <div 
                    style={{ padding:'1rem',height: '10vh',overflow:'scroll' }}
                >
                    {checkedList.map(option => {
                        let process_name = '';
                        const element = processes.find(item => item.process_id === option, {});
                        if (element && 'process_name' in element) {
                            process_name = element.process_name
                        }
                        return (<>
                            <Tag color="lime" style={{}}>{process_name}</Tag>
                        </>)
                    })}
                </div>
            </Card>
            <Card
                title={<Typography.Title level={3}>{props.titleSetting.processes}</Typography.Title>}
            >
                <div
                    style={{
                        height: '30vh', overflow: 'scroll'
                    }}
                >
                    <Row>
                        {processes.map(item =>
                            <Col>
                                <Checkbox value={item.process_id} detail={item.detail} checked={checkedList.includes(item.process_id)} onChange={onChange}>{item.process_name}</Checkbox>
                            </Col>
                        )}
                    </Row>
                </div>
            </Card>
        </Modal_ot>
    </>)
}

const style = {
    border: "none",
    cursor: "move"
}

const DndCard = (props) => {
    const ref = useRef(null)

    let id = props.id;
    let index = props.index;
    let group_type = props.group_type;
    let group_index = props.group_index;

    const [{ handlerId , canDrop , isOver }, drop] = useDrop({
        accept: ItemTypes.CARD,
        collect(monitor) {
            return {
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop(),
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item, monitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = item.index
            const hoverIndex = index
            
            if (group_type !== item.group_type) {
                return
            }
            
            if (group_type === 'process' && group_index !== item.group_index) {
                return
            }

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }

            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()

            if(props.direction === 'vertical') {
                const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
                const clientOffset = monitor.getClientOffset()
                const hoverClientY = clientOffset.y - hoverBoundingRect.top
                if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                    return
                }
                if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                    return
                }
            }
            else {
                // Get horizon middle
                const hoverMiddleX = (hoverBoundingRect.left - hoverBoundingRect.right) / 2
                // Determine mouse position
                const clientOffset = monitor.getClientOffset()
                // Get pixels to the top
                const hoverClientX = clientOffset.x - hoverBoundingRect.right
                // Only perform the move when the mouse has crossed half of the items height
                // When dragging downwards, only move when the cursor is below 50%
                // When dragging upwards, only move when the cursor is above 50%
                // Dragging downwards
                if (dragIndex < hoverIndex && hoverClientX < hoverMiddleX) {
                    return
                }
                // Dragging upwards
                if (dragIndex > hoverIndex && hoverClientX > hoverMiddleX) {
                    return
                }
            }
            // Time to actually perform the action
            props.moveCard(dragIndex, hoverIndex, props.group_index, isOver)
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })
    const [{ isDragging }, drag] = useDrag({
        type: ItemTypes.CARD,
        item: () => {
            return { id, index, group_type, group_index }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            const dragIndex = item.index
            if (item && dropResult) {
                props.dropCard(dragIndex, group_index)
            }
        },
    })
    const opacity = isDragging ? 0 : 1
    drag(drop(ref))
    return (
        <div ref={ref} style={{ ...style, opacity }} data-handler-id={handlerId}>
            {props.children}
        </div>
    )
}